"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgCrossFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M10 7H6c-1.267.001-1.901.668-1.901 2.001 0 1.333.634 1.999 1.9 1.999H10v9c.003 1.2.67 1.8 2.002 1.802C13.334 21.804 14 21.202 14 20v-9h4c1.267-.05 1.901-.716 1.901-1.999 0-1.283-.634-1.95-1.901-2.001h-4V4c0-1.333-.666-2-1.998-2-1.332 0-2 .667-2.002 2v3z' }))); };
exports.default = SvgCrossFilled;
//# sourceMappingURL=CrossFilled.js.map